import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatAud(amount: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatSettlement(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return 'N/A'
  if (trimmed.toLowerCase().includes('flex')) return trimmed
  if (trimmed.toLowerCase().includes('day')) return trimmed
  return `${trimmed} days`
}

export function formatDeposit(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return 'N/A'
  if (trimmed.toLowerCase().includes('flex')) return trimmed
  if (trimmed.includes('%')) return trimmed
  return `${trimmed}%`
}

export function relativeTime(date: Date): string {
  const formatter = new Intl.RelativeTimeFormat('en-AU', { numeric: 'auto' })
  const diffMs = date.getTime() - Date.now()
  const abs = Math.abs(diffMs)
  const minute = 60_000
  const hour = 60 * minute
  const day = 24 * hour
  if (abs < hour) return formatter.format(Math.round(diffMs / minute), 'minute')
  if (abs < day) return formatter.format(Math.round(diffMs / hour), 'hour')
  return formatter.format(Math.round(diffMs / day), 'day')
}
